import { render } from "./ClinicsEdit.vue?vue&type=template&id=5a3128bf"
import script from "./ClinicsEdit.vue?vue&type=script&lang=js"
export * from "./ClinicsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__